export * from './getHomeScreenHeroCardContentTag';
